const compareCodePointStrings = (left, right) => {
  const leftRunes = Array.from(String(left || ""));
  const rightRunes = Array.from(String(right || ""));
  const length = Math.min(leftRunes.length, rightRunes.length);
  for (let index = 0; index < length; index += 1) {
    const leftPoint = leftRunes[index].codePointAt(0);
    const rightPoint = rightRunes[index].codePointAt(0);
    if (leftPoint !== rightPoint) return leftPoint < rightPoint ? -1 : 1;
  }
  return leftRunes.length === rightRunes.length ? 0 : leftRunes.length < rightRunes.length ? -1 : 1;
};

// Browser counterpart of naturalTagPathCompare in core/scada/tag for local,
// unpaginated lists. Server-paginated tag rows keep the server's exact order;
// they must never be re-sorted after a page boundary has been chosen.
const compareFoldedNaturalNames = (left, right) => {
  const leftRunes = Array.from(String(left || "").toLowerCase());
  const rightRunes = Array.from(String(right || "").toLowerCase());
  let leftIndex = 0;
  let rightIndex = 0;
  const isDigit = (value) => value >= "0" && value <= "9";
  while (leftIndex < leftRunes.length && rightIndex < rightRunes.length) {
    if (isDigit(leftRunes[leftIndex]) && isDigit(rightRunes[rightIndex])) {
      let leftEnd = leftIndex;
      let rightEnd = rightIndex;
      while (leftEnd < leftRunes.length && isDigit(leftRunes[leftEnd])) leftEnd += 1;
      while (rightEnd < rightRunes.length && isDigit(rightRunes[rightEnd])) rightEnd += 1;
      let leftSignificant = leftIndex;
      let rightSignificant = rightIndex;
      while (leftSignificant < leftEnd && leftRunes[leftSignificant] === "0") leftSignificant += 1;
      while (rightSignificant < rightEnd && rightRunes[rightSignificant] === "0") rightSignificant += 1;
      const leftLength = leftEnd - leftSignificant;
      const rightLength = rightEnd - rightSignificant;
      if (leftLength !== rightLength) return leftLength < rightLength ? -1 : 1;
      const numberOrder = compareCodePointStrings(
        leftRunes.slice(leftSignificant, leftEnd).join(""),
        rightRunes.slice(rightSignificant, rightEnd).join(""),
      );
      if (numberOrder !== 0) return numberOrder;
      leftIndex = leftEnd;
      rightIndex = rightEnd;
      continue;
    }
    const leftPoint = leftRunes[leftIndex].codePointAt(0);
    const rightPoint = rightRunes[rightIndex].codePointAt(0);
    if (leftPoint !== rightPoint) return leftPoint < rightPoint ? -1 : 1;
    leftIndex += 1;
    rightIndex += 1;
  }
  if (leftRunes.length !== rightRunes.length) return leftRunes.length < rightRunes.length ? -1 : 1;
  return 0;
};

// Keep tag and folder ordering aligned across every Gateway picker. The
// backend applies the same numeric-aware policy before pagination; this
// comparator keeps locally combined pages and specialized catalogs stable.
export const compareNaturalNames = (left, right) => {
  const leftName = String(left || "");
  const rightName = String(right || "");
  return compareFoldedNaturalNames(leftName, rightName)
    || compareCodePointStrings(leftName, rightName);
};

export const compareTagRows = (left, right) => compareNaturalNames(
  left?.name || left?.path || left?.fullPath || left?.full_path,
  right?.name || right?.path || right?.fullPath || right?.full_path,
) || compareNaturalNames(
  left?.fullPath || left?.full_path || left?.path,
  right?.fullPath || right?.full_path || right?.path,
);

export const compareFolderRows = (left, right) => {
  if (Boolean(left?.system) !== Boolean(right?.system)) return left?.system ? -1 : 1;
  return compareNaturalNames(left?.name, right?.name);
};
